import { Component, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CompartilhadoService } from './services/compartilhado/compartilhado.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  title = 'Portal';
  exibirTemplate: boolean;

  constructor(
    private router:Router,
    private elementRef: ElementRef,
    //private compartilhadoUsuarioService: CompartilhadoUsuarioService
    public compartilhadoService: CompartilhadoService
  ) {
    router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;

        // Lista de rotas que NÃO devem exibir o template
        const rotasSemTemplate = [
          '/esqueci-minha-senha',
          '/login',
          '/cadastrar-senha',
          '/cadastro-associados',
          '/verifique-seu-email',
          '/cadastro-realizado-com-sucesso',
          '/pagina-nao-encontrada',
          '/pagina-em-manutencao',
          '/pagina-acesso-negado',
          '**'
        ];

        this.exibirTemplate = !rotasSemTemplate.some(r => url.includes(r));
      }
    });

  }


}
